import { DetailRequirement, ProgramBenchmarkName, ProgramModel } from '@cibo/core'
import { flatten, map, pipe, uniq } from 'ramda'
import { useProgramConfigs } from '../queries'

export const combinedBenchmarkRequirements = ({
  benchmark,
  programs,
}: {
  benchmark: ProgramBenchmarkName
  programs: ProgramModel[]
}) => {
  const combineRequirements = pipe<
    ProgramModel[],
    DetailRequirement[][],
    DetailRequirement[],
    DetailRequirement[]
  >(
    map((program: ProgramModel) => program.requiredDetails(benchmark)),
    flatten,
    uniq
  )

  const combinedRequirements: DetailRequirement[] = combineRequirements(programs)

  //use only the most complicated required details
  const mappedRequirements = new Map<string, DetailRequirement>()
  combinedRequirements?.forEach(requirement => {
    const key = `${requirement.traitId}_${requirement.year}}`
    if (mappedRequirements.has(key)) {
      const existing = mappedRequirements.get(requirement.traitId)
      if (!!existing && !requirement.resultsOnly) {
        if (!!existing.resultsOnly) {
          mappedRequirements.set(key, requirement)
        } else {
          mappedRequirements.set(key, {
            ...existing,
            reqAttrs: uniq([...(existing.reqAttrs || []), ...(requirement.reqAttrs || [])]),
          } as DetailRequirement)
        }
      } else {
        mappedRequirements.set(key, requirement)
      }
    } else {
      mappedRequirements.set(key, requirement)
    }
  })

  return Array.from(mappedRequirements.values())
}

export const useCombinedBenchmarkRequirements = (
  benchmark: ProgramBenchmarkName = 'profile',
  filter: (model: ProgramModel) => boolean = model => true
) => {
  const configsQuery = useProgramConfigs()
  const models = configsQuery.data

  return {
    ...configsQuery,
    data: combinedBenchmarkRequirements({
      benchmark,
      programs: models?.filter(filter) || [],
    }),
  }
}
